import React from 'react';

const GoalsPage: React.FC = () => (
  <div>
    <h1>Goals Page</h1>
    <p>Coming soon...</p>
  </div>
);

export default GoalsPage;
